
const authLogin = ({ commit }, auth) => {
  commit('setAuth', auth)
}

const authLogout = ({ commit }) => {
  commit('setAuth')
}

export default {
  authLogin,
  authLogout
}



// WEBPACK FOOTER //
// ./src/store/modules/security/actions.js